import { render, staticRenderFns } from "./CotAllertComponent.vue?vue&type=template&id=5d98749c"
import script from "./CotAllertComponent.vue?vue&type=script&lang=js"
export * from "./CotAllertComponent.vue?vue&type=script&lang=js"
import style0 from "./CotAllertComponent.vue?vue&type=style&index=0&id=5d98749c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports